export var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getUserListlAction";
    Actions["GET_DETAIL"] = "getUserDetailAction";
    Actions["POST_DATA"] = "postUserAction";
    Actions["UPDATE_DATA"] = "putUserAction";
    Actions["DELETE_DATA"] = "deleteUserAction";
    Actions["GET_USER_GROUP"] = "getUserGroupMutation";
    Actions["GET_USER_POSITION"] = "getUserPositionAction";
    Actions["GET_USER_POSITION_LIST"] = "getUserPositionListAction";
    Actions["GET_USER_POSITION_DETAIL"] = "getUserPositionDetailAction";
    Actions["POST_USER_POSITION_DATA"] = "postUserPositionAction";
    Actions["UPDATE_USER_POSITION_DATA"] = "updateUserPositionAction";
    Actions["DELETE_USER_POSITION_DATA"] = "deleteUserPositionAction";
    Actions["CREATE_EXPORT_USER_POSITION"] = "createExportUserPositionAction";
    Actions["CHANGE_EXPORT_USER_POSITION"] = "changeExportUserPositionAction";
    Actions["DOWNLOAD_USER_POSITION"] = "downloadUserPositionAction";
    Actions["UPLOAD_CREATE_USER_POSITION"] = "uploadCreateUserPositionAction";
    Actions["UPLOAD_SUBMIT_CREATE_USER_POSITION"] = "uploadSubmitCreateUserPositionAction";
    Actions["UPLOAD_CHANGE_USER_POSITION"] = "uploadChangeUserPositionAction";
    Actions["UPLOAD_SUBMIT_CHANGE_USER_POSITION"] = "uploadSubmitChangeUserPositionAction";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_ORDER"] = "setUserPositionListOrderByMutation";
    Mutations["SET_USER_LIST"] = "setUserListMutation";
    Mutations["SET_USER_LIST_LOADING"] = "setUserListLoadingMutation";
    Mutations["SET_USER_LIST_PAGINATION"] = "setUserListPaginationMutation";
    Mutations["SET_USER_GROUP_LIST"] = "setUserGroupListMutation";
    Mutations["SET_USER_POSITION_LIST"] = "setUserPositionListMutation";
    Mutations["SET_USER_POSITION_LIST_LOADING"] = "setUserPositionListLoadingMutation";
    Mutations["SET_USER_POSITION_LIST_PAGINATION"] = "setUserPositionListPaginationMutation";
    Mutations["SET_USER_POSITION_LIST_FILTER"] = "setUserPositionListFilterMutation";
    Mutations["RESET_USER_POSITION_LIST_FILTER"] = "resetUserPositionListFilterMutation";
})(Mutations || (Mutations = {}));
